"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Mover = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Mover, _Component);

  var _super = _createSuper(Mover);

  function Mover() {
    var _this;

    (0, _classCallCheck2.default)(this, Mover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      show: null
    });
    return _this;
  }

  (0, _createClass2.default)(Mover, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$ref;

      if (nextProps.x === this.props.x && nextProps.y === this.props.y) return;
      if (!((_this$ref = this.ref) !== null && _this$ref !== void 0 && _this$ref.parentElement)) return;
      var rect = this.ref.parentElement.getBoundingClientRect();
      var x = nextProps.x,
          y = nextProps.y;
      var inside = x > rect.left - 65 && y > rect.top && x < rect.right && y < rect.bottom;
      if (!inside) return this.setState({
        show: null
      });
      var topOrBottom = (rect.bottom + rect.top) / 2 > y ? 'top' : 'bottom';
      var resolvedX = rect.left;
      var resolvedY = topOrBottom === 'top' ? rect.top + 1 : rect.bottom;
      var bodyRect = document.body.getBoundingClientRect();
      this.props.resolvedPosition(topOrBottom, Math.round(resolvedX - bodyRect.left), Math.round(resolvedY - bodyRect.top), rect.width);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.show !== this.state.show || this.props.children !== nextProps.children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return (0, _preact.h)("div", {
        ref: function ref(_ref) {
          return _this2.ref = _ref;
        }
      }, this.props.children);
    }
  }]);
  return Mover;
}(_preact.Component);

exports.default = Mover;